import React from 'react'

const withMapList = mapFunction => WrappedComponent => {
  return function(props) {
    const {data} = props
    const list = data.map(mapFunction)
    return <WrappedComponent {...props} data={list} />
  }
}
export default withMapList
